<template>
  <div>
    <edit-client-view></edit-client-view>
  </div>
</template>
<script>
import editClientView from "./editClientView";
export default {
  name: 'newClient',
  components: {
    editClientView
  }
}
</script>
